export default function VehicleFormField({ name, label, value, onChange, onBlur, placeholder, numeric = false, maxLength, disabled, error, inputRef }) {
  return <div className="veh-reg__field">
    <label className="veh-reg__label" htmlFor={`veh-reg-${name}`}>{label}</label>
    <input ref={inputRef} id={`veh-reg-${name}`} className={`veh-reg__input${error ? ' veh-reg__input--error' : ''}`} type="text" value={value} onChange={onChange} onBlur={onBlur} placeholder={placeholder} autoComplete="off" inputMode={numeric ? 'numeric' : undefined} maxLength={maxLength} disabled={disabled} aria-invalid={Boolean(error)} />
    {error && <p className="veh-reg__field-error">{error}</p>}
  </div>;
}
